import React, { useState } from 'react';
import { Dialog } from '@ordr-as/umami-react/dialog';
import { TextInput } from '@ordr-as/umami-react/form';
import { MenuItemVariantDto } from '../../../../../generated-api';
import { formatWithCurrency } from '../../../../utils/format';

interface Props {
  item: MenuItemVariantDto;
  isOpen: boolean;
  addItemToCart: (quantity: number) => void;
  onClose: () => void;
}

const WeightPriceDialog = (props: Props) => {
  const { isOpen, item, onClose, addItemToCart } = props;
  const [inputValue, setInputValue] = useState<string>('');

  if (!isOpen) {
    return null;
  }

  const quantity = inputValue ? parseFloat(inputValue) : undefined;

  const handleTextInputChange = (value: string) => {
    if (value === '') {
      setInputValue('');
      return;
    }

    const parsedValue = parseFloat(value);
    const isNotvalid = isNaN(parsedValue);

    if (isNotvalid) {
      return;
    }

    setInputValue(value);
  };

  const handleAddItemToCart = () => {
    if (!quantity) {
      return;
    }

    addItemToCart(quantity);
    onClose();
  };

  const getUnit = () => {
    if (item.priceType === 'PER_KG') {
      return 'Kilos';
    }

    if (item.priceType === 'PER_HG') {
      return 'Hektograms';
    }

    return 'Grams';
  };

  const takeAwayPrice = item.takeawayPrice && quantity ? item.takeawayPrice * quantity : undefined;
  const eatInPrice = item.price && quantity ? item.price * quantity : 0;

  const actionLabel =
    `Add to cart ${formatWithCurrency(eatInPrice, 'NOK')}` +
    (takeAwayPrice ? ` | ${formatWithCurrency(takeAwayPrice, 'NOK')}` : '');

  return (
    <Dialog
      aria-label="Weight price dialog"
      alignTop
      title={`Add ${item.name} to cart`}
      onClose={onClose}
      actionLabel={actionLabel}
      onAction={handleAddItemToCart}
      isDisabledAction={!quantity || quantity <= 0}
    >
      <div className="flex gap-4">
        <TextInput
          type="number"
          className="w-[180px]"
          required
          label="Weight"
          value={inputValue}
          onChange={handleTextInputChange}
        />
        <p className="relative top-[35px]"> {getUnit()} </p>
      </div>
    </Dialog>
  );
};

export default React.memo(WeightPriceDialog);
